import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Controller, useForm } from 'react-hook-form';
import { saveCustomer } from '../../../actions/customerActions';
import { toast } from 'react-toastify';

export default function AddCustomerStep1() {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    getValues,
  } = useForm();
  const onSubmit = (data) => {
    saveCustomer({
      customerId: data.customerId,
      customerName: data.customerName,
    }).then(() => {
      toast.success('Customer added');
      navigate('/customers');
    });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="row">
        <div className="col">
          <h1 className="d-flex align-items-center justify-content-between">
            <span>
              <i className="fa-light fa-circle-plus me-2"></i>Add customer
            </span>
            <input type="submit" className="btn btn-primary float-end" />
          </h1>
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-xl-8">
          <div className="card">
            <div className="card-body">
              <h2>Customer Details</h2>
              <div className="form-group row g-0">
                <label className="col-4">
                  <i className="fa-light fa-hashtag me-2 blue"></i>Customer name
                </label>
                <div className="col-8">
                  <input
                    type="text"
                    required
                    autoComplete="off"
                    className="form-control"
                    placeholder="customer name"
                    {...register('customerName', {})}
                  />
                  {errors.customerName && (
                    <span className="field-validation-error">Required</span>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <input type="submit" className="btn btn-primary float-end" />
        </div>
      </div>
    </form>
  );
}
